// extracted by mini-css-extract-plugin
export default {"boardItem":"CurrentFortune500_boardItem__Y9JQD","fortune500":"CurrentFortune500_fortune500__Cc0aB","relevantIcon":"CurrentFortune500_relevantIcon__Um1Lt"};